"use strict";
/*
 * Created on 02 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var ExportedOptimizationScenarioConverter_1 = require("./conversions/ExportedOptimizationScenarioConverter");

var ExportedOptimizationScenarioConverterImpl_1 = require("./conversions/ExportedOptimizationScenarioConverterImpl");

var OptimalMarginGraphDataConverter_1 = require("./conversions/OptimalMarginGraphDataConverter");

var OptimalMarginGraphDataConverterImpl_1 = require("./conversions/OptimalMarginGraphDataConverterImpl");

var OptimizationGraphConverter_1 = require("./conversions/OptimizationGraphConverter");

var OptimizationGraphConverterImpl_1 = require("./conversions/OptimizationGraphConverterImpl");

var OptimizationGraphDataConverter_1 = require("./conversions/OptimizationGraphDataConverter");

var OptimizationGraphDataConverterImpl_1 = require("./conversions/OptimizationGraphDataConverterImpl");

var OptimizationScenarioConverter_1 = require("./conversions/OptimizationScenarioConverter");

var OptimizationScenarioConverterImpl_1 = require("./conversions/OptimizationScenarioConverterImpl");

var OptimizationScenarioDataConverter_1 = require("./conversions/OptimizationScenarioDataConverter");

var OptimizationScenarioDataConverterImpl_1 = require("./conversions/OptimizationScenarioDataConverterImpl");

var StrategyGraphDataConverter_1 = require("./conversions/StrategyGraphDataConverter");

var StrategyGraphDataConverterImpl_1 = require("./conversions/StrategyGraphDataConverterImpl");
/**
 * @author Jaroslav Sevcik
 */


var OptimizationScenarioAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(OptimizationScenarioAppModule, _AppModule_1$AppModul);

  function OptimizationScenarioAppModule() {
    var _this;

    _classCallCheck(this, OptimizationScenarioAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimizationScenarioAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'optimizationScenarioAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(OptimizationScenarioAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(OptimizationGraphDataConverter_1.OptimizationGraphDataConverter).to(OptimizationGraphDataConverterImpl_1.OptimizationGraphDataConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(OptimizationGraphConverter_1.OptimizationGraphConverter).to(OptimizationGraphConverterImpl_1.OptimizationGraphConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(StrategyGraphDataConverter_1.StrategyGraphDataConverter).to(StrategyGraphDataConverterImpl_1.StrategyGraphDataConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(OptimizationScenarioDataConverter_1.OptimizationScenarioDataConverter).to(OptimizationScenarioDataConverterImpl_1.OptimizationScenarioDataConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(OptimalMarginGraphDataConverter_1.OptimalMarginGraphDataConverter).to(OptimalMarginGraphDataConverterImpl_1.OptimalMarginGraphDataConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(OptimizationScenarioConverter_1.OptimizationScenarioConverter).to(OptimizationScenarioConverterImpl_1.OptimizationScenarioConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ExportedOptimizationScenarioConverter_1.ExportedOptimizationScenarioConverter).to(ExportedOptimizationScenarioConverterImpl_1.ExportedOptimizationScenarioConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return OptimizationScenarioAppModule;
}(AppModule_1.AppModule);

exports.OptimizationScenarioAppModule = OptimizationScenarioAppModule;